import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import pauseDesctop from './../../../shared/assets/images/covid/pause.png';
import MainButton from '../../Button/MainButton';
import Button from '../../Button/Button';
import lang from '../../../lang/lang.json';
import { connect } from 'react-redux';
import './payment.scss';

class Payment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    const windowWidth = window.innerWidth;

    if (windowWidth && windowWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
  }

  render() {
    const link = (
      <a className="linkFormA" href="#form">
        {this.state.isMobile ? (
          <Button
            textStyle="normal"
            text={lang.SLIDER_BUTTON[this.props.language]}
            variant="primary"
          ></Button>
        ) : (
          <MainButton
            textStyle="normal"
            text={lang.SLIDER_BUTTON[this.props.language]}
            variant="primary"
          ></MainButton>
        )}
      </a>
    );

    return (
      <div className="Mobi">
        <div className="container">
          <div className="row bg-image">
            <div className="col-lg-7 col-bg">
              <div className="row pb-3 pt-md-5">
                <div className="col">
                  <div className="title">
                    {lang.SLIDER_TITLE[this.props.language]}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="description">
                    {lang.SLIDER_DESCRIPTION[this.props.language]}
                  </div>
                  {window.innerWidth > 992 ? link : <></>}
                </div>
              </div>
            </div>
            <div className="col">
              <div className="phone-block text-center">
                <Fade right>
                  <img src={pauseDesctop} alt="" className="phone" />
                </Fade>
              </div>
              <div className="phone-margin">
                {window.innerWidth < 992 ? link : <></>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.language.language,
});

export default connect(mapStateToProps)(Payment);
